import React from "react";
import { COLORS } from "../constants";
import { MasdarPayslip } from "../types";

interface MasdarPayslipViewProps {
  payslipData?: MasdarPayslip[];
}

type DisplayablePayslipKeys = Exclude<keyof MasdarPayslip, "">;

const PAY_SLIP_COLUMNS: {
  header: string;
  key: DisplayablePayslipKeys;
}[] = [
  { header: "Establishment Name", key: "establishmentName" },
  { header: "National Unified Number", key: "nationalUnifiedNumber" },
  { header: "Period", key: "period" },
  { header: "Basic Salary", key: "basicSalary" },
  { header: "Housing Allowance", key: "housingAllowance" },
  { header: "Other Amount", key: "otherAmount" },
  { header: "Deduction Amount", key: "deductionAmount" },
  { header: "Net Paid Amount", key: "netPaidAmount" },
  { header: "Bank Account", key: "bankAccount" },
  { header: "Bank Name", key: "bankName" },
  { header: "Bank Code", key: "bankCode" },
];

const MasdarPayslipView: React.FC<MasdarPayslipViewProps> = ({
  payslipData = [],
}) => {
  if (!payslipData.length) return null;

  return (
    <div className="table-responsive" style={{ marginTop: 10 }}>
      <p
        className="text-dark m-0"
        style={{
          fontFamily: "Cairo",
          fontWeight: 500,
          fontSize: "20px",
        }}
      >
        Payslip
      </p>
      <hr />
      {/* <table
        className="table text-center table-border spaced-table"
        style={{ minWidth: "100%" }}
      > */}
      <table className="table text-center spaced-table">
        {/* HEADER */}
        <thead style={{ background: COLORS.BG_LIGHTER }}>
          <tr style={{ color: COLORS.TEXT_MUTED }}>
            {PAY_SLIP_COLUMNS.map((col, index) => (
              <th key={`${col.header}-${index}`} style={{ maxWidth: 100 }}>{col.header}</th>
            ))}
          </tr>
        </thead>

        {/* BODY */}
        <tbody style={{ color: COLORS.TEXT_MUTED, fontSize: "small" }}>
          {payslipData.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {PAY_SLIP_COLUMNS.map((col, colIndex) => {
                const value = col?.key ? row[col.key] || "" : "";
                return <td key={`${col?.header}-${colIndex}`}>{value}</td>;
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MasdarPayslipView;
